import React, { FunctionComponent } from 'react';
import FormHeader from '../../Form/FormHeader';
import styles from '../SSOForm/SSOForm.module.scss';
import { Link } from 'react-router-dom';
import { routes } from '../../../shared/constants';
import SSOFilterContainer from '../SSOFilter/SSOFilterContainer';
import { SSOProperty } from '../../../store/sso/types';
import hiltonImage from '../../../assets/SSOLogos/Hilton.png';

const userServiceBaseUrl: string = process.env.REACT_APP_USER_SERVICE_BASE_URL || ''
const hiltonUrl: string = process.env.REACT_APP_HILTON_SSO_URL || ''
let brandName: string = 'Hilton SSO'

if (process.env.REACT_APP_ENV !== 'prod') {
    brandName = brandName + ' Stage'
}

const ssoProperties: SSOProperty[] = [
  {
    id: 1,
    brand: brandName,
    imagePath: hiltonImage,
    redirect: userServiceBaseUrl + '/oauth/login?iss=' + hiltonUrl
  }
];

const SSOForm: FunctionComponent = () => {
  return (
    <form className={styles.form}>
      <FormHeader />
      <SSOFilterContainer properties={ssoProperties} />
      <footer className={styles.footer}>
        <Link to={routes.USERNAME_FORM} aria-label="Return to username form">
          <span className={styles.background} aria-hidden="true">
            {' '}
          </span>
          <span className={styles.link}>Back</span>
        </Link>
      </footer>
    </form>
  );
};

export default SSOForm;
